import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LuUsers } from 'react-icons/lu';
import AuthContext from '../../components/shared/AuthContext';

export default function TeamGroupsPage() {
  const { orgId } = useParams();
  const { apiClient } = useContext(AuthContext);
  const [groups, setGroups] = useState([]);
  const [members, setMembers] = useState([]);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [addUserId, setAddUserId] = useState('');
  const [selectedGroupId, setSelectedGroupId] = useState('');
  const [error, setError] = useState('');

  const load = () => apiClient.get(`/api/organizations/${orgId}/groups`).then((r) => setGroups(r.data || []));

  useEffect(() => {
    load().catch(() => setError('Could not load groups.'));
    apiClient.get(`/api/organizations/${orgId}/members`).then((r) => setMembers(r.data || [])).catch(() => {});
  }, [apiClient, orgId]);

  const create = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await apiClient.post(`/api/organizations/${orgId}/groups`, { name, description });
      setName('');
      setDescription('');
      await load();
    } catch (err) {
      setError(err.response?.data?.message || 'Could not create group.');
    }
  };

  const addMember = async (e) => {
    e.preventDefault();
    if (!selectedGroupId || !addUserId) return;
    setError('');
    try {
      await apiClient.post(`/api/organizations/${orgId}/groups/${selectedGroupId}/members`, {
        userId: Number(addUserId),
      });
      setAddUserId('');
      await load();
    } catch (err) {
      setError(err.response?.data?.message || 'Could not add member.');
    }
  };

  return (
    <>
      <div className="teams-card">
        <h2><LuUsers aria-hidden /> Create group</h2>
        <p className="teams-sub">Add members to a group, then assign learning to that group on the Assignments tab.</p>
        {error && <div className="teams-error" role="alert">{error}</div>}
        <form onSubmit={create}>
          <div className="teams-form-row">
            <label htmlFor="group-name">Name</label>
            <input id="group-name" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="teams-form-row">
            <label htmlFor="group-desc">Description</label>
            <input id="group-desc" value={description} onChange={(e) => setDescription(e.target.value)} />
          </div>
          <button type="submit" className="teams-btn">Add group</button>
        </form>
      </div>

      <div className="teams-card">
        <h2>Add member to group</h2>
        <form onSubmit={addMember} className="teams-form-row" style={{ gap: 10 }}>
          <div>
            <label htmlFor="pick-group">Group</label>
            <select id="pick-group" value={selectedGroupId} onChange={(e) => setSelectedGroupId(e.target.value)} required>
              <option value="">Select…</option>
              {groups.map((g) => (
                <option key={g.id} value={g.id}>{g.name}</option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="pick-user">Member</label>
            <select id="pick-user" value={addUserId} onChange={(e) => setAddUserId(e.target.value)} required>
              <option value="">Select…</option>
              {members.map((m) => (
                <option key={m.userId} value={m.userId}>{m.name || m.email}</option>
              ))}
            </select>
          </div>
          <button type="submit" className="teams-btn">Add to group</button>
        </form>
      </div>

      <div className="teams-org-grid">
        {groups.length === 0 ? (
          <p className="teams-sub">No groups yet.</p>
        ) : (
          groups.map((g) => (
            <div key={g.id} className="teams-org-card">
              <strong>{g.name}</strong>
              {g.description && <p className="teams-sub">{g.description}</p>}
              <p className="teams-sub">{g.memberCount ?? 0} members</p>
            </div>
          ))
        )}
      </div>
    </>
  );
}
